import { fullSources } from 'customHooks/useDataSources';
import { metricFunction } from 'API';
import { placeholderFullSources } from 'components/newSetup/PlaceholderContainer';

/**
 * Processes a dataSource to prepare it for query generation
 * This function is shared between Main.tsx and AddCreativeLibrarySectionModal.tsx
 */
export const processDataSource = (dataSource: fullSources): placeholderFullSources => {
  return {
    ...dataSource,
    metrics:
      dataSource.metrics?.map((metric) => ({
        ...metric,
        isSelected: true,
        detailedMetric: {
          column: metric.metric === 'Start date' || metric.metric === 'End date' ? 'date' : metric.metric,
          aggregation:
            metric.metric?.endsWith('_reach') ||
            metric.metric?.endsWith('_recallers') ||
            metric.metric?.startsWith('sub_rf_') ||
            metric.metric === 'effective_frequency' ||
            metric.metric === 'reach' ||
            metric.metric === 'frequency' ||
            metric.metric === 'date' ||
            metric.metric === 'End date'
              ? metricFunction.MAX
              : metric.metric === 'Start date'
                ? metricFunction.MIN
                : metricFunction.SUM,
          decimals:
            metric.metric === 'Start date' || metric.metric === 'End date'
              ? -1
              : metric.metric === 'impressions' || metric.metric === 'clicks'
                ? 0
                : 5,
          id: metric.metric,
          name: metric.metric,
        },
      })) || [],
    dimensions:
      dataSource.dimensions?.map((dimension) =>
        dimension.dimension === 'creative_name' || dimension.dimension === 'creative_id'
          ? {
              ...dimension,
              isSelected: true,
              detailedDimension: {
                column: dimension.dimension,
                hidden: false,
                id: dimension.dimension,
                name: dimension.dimension,
              },
            }
          : dimension,
      ) || [],
    calcMetrics:
      dataSource.calcMetrics?.map((calcMetric) => ({
        ...calcMetric,
        isSelected: true,
        decimals: 5,
        id: calcMetric.name,
      })) || [],
  } as placeholderFullSources;
};